import type { FaireProductEntity } from "../../entity_types/product";

export const p_94svn2sh3e: FaireProductEntity = {
  token: "p_94svn2sh3e",
  type: "product",
  name: "Boho Geometric Print Drawstring Wide Leg Pants",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/40b60cdddc5143cc4ecb11db9877f2bfbe26aeec4a2740f4ae82ba4713cb2425.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/721fdbbfc6b254ed4da1f701714530baa711bfcd866046bae6dc3db02325b2aa.jpeg",
    "https://cdn.faire.com/fastly/2f85a7b01a497fb7765766f9b5b525b749d1a12d11eba80b327ba88f1ef11fab.jpeg",
    "https://cdn.faire.com/fastly/3f4006a24c63425214661fb180e544268dc360ccaf3ff934061282bb122736fe.jpeg",
    "https://cdn.faire.com/fastly/a28729190554b2ef1a1973cfb271476d8d7ff14a1889332353c3df7ea0294766.jpeg",
    "https://cdn.faire.com/fastly/fa16f8bca4d416392ac0a2ec1801415b9d383b4e1a0e238881fe798b377502ab.jpeg",
    "https://cdn.faire.com/fastly/1af3b4ee33dd0c1e6696aef9a88c4604230623cdbc5a2a8ac9bc767b6a984e4e.jpeg",
    "https://cdn.faire.com/fastly/8d4d9879da6c65c11ac2d340c0880bfe5cd51126a20c887413c80860c0a3a9f6.jpeg",
    "https://cdn.faire.com/fastly/42268aeb08ea6d1d7dd496b451af7943d58f47a73c1de3710813fee92ea089cf.jpeg",
    "https://cdn.faire.com/fastly/b4d2abe5da7c7dd3ac44e954775552af39fbe55703daf16396d5806e0ba6787d.jpeg",
  ],
  priceDollars: 17.9,
  description:
    "Boho Geometric Print Drawstring Wide Leg Pants_RCDQ02777\n\nOur product size standards are different, please check the size information before placing an order\t\t\t\t\t\t\t\t\n\nSize Chart(Inch)\t\t\t\n\t   Waist\t Hip\t    Length\nS  \t27.2  \t45.5  \t39.7\nM  \t29.2  \t47.7  \t40.2\nL  \t31.9  \t50.7  \t40.7\nXL\t34.7  \t53.7  \t41.1\n2XL\t37.4  \t56.7  \t41.6\n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 35.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:00.621Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
